import { render, staticRenderFns } from "./PostponementRequest.vue?vue&type=template&id=f8703fa2&scoped=true&"
import script from "./PostponementRequest.vue?vue&type=script&lang=js&"
export * from "./PostponementRequest.vue?vue&type=script&lang=js&"
import style0 from "./PostponementRequest.vue?vue&type=style&index=0&id=f8703fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8703fa2",
  null
  
)

export default component.exports